<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 16">
    <path
      d="M0.602539 1.11667C0.602539 0.629932 0.997119 0.235352 1.48386 0.235352H15.585C16.0717 0.235352 16.4663 0.629932 16.4663 1.11667V1.11667C16.4663 1.60341 16.0717 1.99799 15.585 1.99799H1.48386C0.99712 1.99799 0.602539 1.60341 0.602539 1.11667V1.11667ZM0.602539 14.3365C0.602539 13.8497 0.997119 13.4551 1.48386 13.4551H15.585C16.0717 13.4551 16.4663 13.8497 16.4663 14.3365V14.3365C16.4663 14.8232 16.0717 15.2178 15.585 15.2178H1.48386C0.99712 15.2178 0.602539 14.8232 0.602539 14.3365V14.3365ZM7.65309 9.92987C7.65309 9.44313 8.04767 9.04855 8.53441 9.04855H15.585C16.0717 9.04855 16.4663 9.44313 16.4663 9.92987V9.92987C16.4663 10.4166 16.0717 10.8112 15.585 10.8112H8.53441C8.04767 10.8112 7.65309 10.4166 7.65309 9.92987V9.92987ZM7.65309 5.52327C7.65309 5.03653 8.04767 4.64195 8.53441 4.64195H15.585C16.0717 4.64195 16.4663 5.03653 16.4663 5.52327V5.52327C16.4663 6.01001 16.0717 6.40459 15.585 6.40459H8.53441C8.04767 6.40459 7.65309 6.01001 7.65309 5.52327V5.52327ZM1.02486 8.0961C0.801284 7.90047 0.801285 7.55266 1.02486 7.35704L3.31346 5.35451C3.63094 5.07671 4.12782 5.30218 4.12782 5.72404V9.72909C4.12782 10.151 3.63094 10.3764 3.31346 10.0986L1.02486 8.0961Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
